import { useMutation, useQueryClient } from "@tanstack/react-query";
import { GoalsKeys } from "web_myplann/Api/Goals/GoalsKeys";
import {
	type GoalDetailResponseDTO,
	putGoalIdV2,
	type UpdateGoalRequestDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

type GoalUnpinPortfolioVariables = {
	id: number;
	portfolioId: number;
	body: UpdateGoalRequestDTO;
};

export const useGoalUnpinPortfolioMutation = () => {
	const queryClient = useQueryClient();

	return useMutation<GoalDetailResponseDTO, Error, GoalUnpinPortfolioVariables>(
		{
			mutationFn: processResponse(({ id, body }: GoalUnpinPortfolioVariables) =>
				putGoalIdV2(body, id),
			),
			onSuccess: (data, variables) => {
				queryClient.setQueryData<GoalDetailResponseDTO>(
					GoalsKeys.detail(variables.id),
					data,
				);
				queryClient.invalidateQueries({ queryKey: GoalsKeys.lists() });
				queryClient.invalidateQueries({
					queryKey: GoalsKeys.detailPortfolios(),
				});
			},
		},
	);
};
